import { baseUrl } from "./env";
import store from "@/store";
import router from "@/router/index";

import { message } from 'ant-design-vue'
import axios from "axios";
import download from "downloadjs";
let httpTimeout = 100000;
// const router = useRouter();
// const route = useRoute();

axios.interceptors.request.use(
  (config) => {
    // if (store.getters.token && config.url.indexOf("ChangePwdByEmail") < 0) {
    config.headers.Authorization = store.getters.token;
    // }
    config.headers.lang = store.getters.language;

    if (store.getters.angleOfView == 2) config.headers.roleid = store.getters.role;

    if (config.url.indexOf("?") < 0)
      config.url = config.url + "?r=" + Math.random();
    else config.url = config.url + "&r=" + Math.random(); //IE对API有缓存，要加随机参数
    store.commit('setloadding', true) // 全局loading
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    store.dispatch('loaddingAct', false) // 全局loading
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit("Logout");
      }
    }
    return Promise.resolve(error.response);
  }
);

function checkStatus(response) {
  /**如果状态码正常 */
  const { config } = response;
  if (config &&
    (config.url.includes("AzureAdUsers") || config.url.includes("CheckLicenseState"))
  ) {
    //AzureAdUsers的返回数据结构只是一个布尔值，故也要跳过isSuccess的校验
    // CheckLicenseState 返回false也要进行数据请求，所以要在这儿直接返回数据不进行isSuccess的校验
    return response.data;
  } else if (
    response &&
    response.status === 200 &&
    response.data.isSuccess == true
  ) {
    /**如果当前操作是成功的，判断isSuccess
     * 为true时则直接返回response
     */
    return response.data;
  } else {
    // let alertMessage = ""; let msgType = "info";
    if (response && (response.data.message || response.data.messages)) {

      message.warning(response.data.message || response.data.messages[0]);
    } else {
      // console.log(response);

    }
  }
  return false;
}


function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)
  console.error(res, "HTTP请求的错误信息");

  return false;
}
/**reloading 设置为Y或者N Y为刷新按钮不添加加载动画，只加载按钮动画 */
export default {
  post(url, params?) {
    if (
      url.indexOf("InitQMC") > 0 ||
      url.indexOf("AuthorizationSoftware") > 0
    ) {
      httpTimeout = 360000;
    } else {
      httpTimeout = 100000;
    }

    return axios({
      method: "post",
      url: baseUrl + url,
      data: params,
      timeout: httpTimeout,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then((response) => {
        return checkStatus(response);
      })
      .catch((res) => {
        return checkCode(res);
      });
  },
  postfile(url, params?) {
    return axios({
      method: "post",
      url: baseUrl + url,
      data: params,
      timeout: httpTimeout,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        return checkStatus(response);
      })
      .catch((res) => {
        return checkCode(res);
      });
  },
  get(url, params?) {
    if (
      url.indexOf("InitQMC") > 0 ||
      url.indexOf("AuthorizationSoftware") > 0 || url.indexOf("Teams/AzureAdUsers") > 0
    ) {
      httpTimeout = 360000;
    } else {
      httpTimeout = 100000;
    }

    return axios({
      method: "get",
      url: baseUrl + url,
      params, // get 请求时带的参数
      timeout: httpTimeout,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        return checkStatus(response);
      })
      .catch((res) => {
        return checkCode(res);
      });
  },
  // responseType: 'blob'
  /**二进制流的文件下载 */
  getBlobFile(url, params?) {
    return axios({
      method: "get",
      url: baseUrl + url,
      params, // get 请求时带的参数
      timeout: httpTimeout,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      responseType: "blob",
    })
      .then((response) => {
        const disposition = response.headers["content-disposition"];

        const fileName = disposition
          ? window.decodeURI(
            disposition
              .split(";")[2]
              .split("=")[1]
              .split("''")[1]
          )
          : null;

        if (fileName) {
          const blob = new Blob([response.data]);
          download(blob, fileName);
        } else {
          return {
            fileName,
            isDownloadFailed: true,
          };
        }
      })
      .catch((res) => {
        return checkCode(res);
      });
  }
};

